import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';
import withBalance from 'shared/hocs/withBalance';
import Loader from 'shared/components/Loader/Loader';
import { PAYMENT_METHODS } from '../../constants/payment';
import cardImg from '../../assets/images/credit-card.svg';
// import p24Img from './payment-4.svg';
// import billImg from './receipt.svg';
import s from './PaymentModal.css';

class PaymentModal extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    closeHandler: PropTypes.func.isRequired,
    agreeHandler: PropTypes.func.isRequired,
    amount: PropTypes.number.isRequired,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
        imgSrc: PropTypes.string,
      }),
    ),
    isLoading: PropTypes.bool,
    isFetching: PropTypes.bool.isRequired,
    balance: PropTypes.number,
    balanceRefillMode: PropTypes.bool,
    disableBalance: PropTypes.bool,
    intl: intlShape.isRequired,
  };
  static defaultProps = {
    balance: null,
    items: [
      {
        title: 'Оплатить с личного счёта',
        imgSrc: cardImg,
        slug: PAYMENT_METHODS.BALANCE,
        isBalanceRefillOption: false,
      },
      {
        title: 'Оплатить картой',
        imgSrc: cardImg,
        slug: PAYMENT_METHODS.MONO,
        isBalanceRefillOption: true,
      },
      // {
      //   title: 'Приват 24',
      //   imgSrc: p24Img,
      //   slug: PAYMENT_METHODS.FONDY_P24,
      //   isBalanceRefillOption: true,
      // },
      // {
      //   title: 'Оплатить квитанцией',
      //   imgSrc: billImg,
      //   slug: PAYMENT_METHODS.INVOICE,
      //   isBalanceRefillOption: true,
      // },
    ],
    isLoading: false,
    balanceRefillMode: false,
    disableBalance: false,
  };

  state = {
    selectedItem: this.props.items[0],
    balanceRefillMode: false,
    isChecked: true,
  };

  componentDidUpdate(prevProps) {
    const { balance, isFetching } = this.props;

    if (prevProps.isFetching && !isFetching) {
      const { selectedItem } = this.state;
      const { amount, items, balanceRefillMode } = this.props;
      const isBalanceEnough = amount <= balance;
      const isPayingForService = !isBalanceEnough || balanceRefillMode;
      const newSelectedItem = isPayingForService
        ? items.find(item => item.slug !== PAYMENT_METHODS.BALANCE)
        : selectedItem;

      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        selectedItem: newSelectedItem,
        balanceRefillMode: isPayingForService,
      });
    }
  }

  handleItemChosen = selectedItem => {
    this.setState({ selectedItem });
    this.props.agreeHandler(selectedItem);
  };

  render() {
    const { intl } = this.props;
    const { amount, closeHandler, title, isLoading, items, balance, isFetching } = this.props;
    const { balanceRefillMode, isChecked } = this.state;
    const isMobile = __APP__ === 'mobile';

    return (
      <div className={s.root}>
        <div className={s.bg} onClick={closeHandler} />
        <div className={s.container}>
          <div className={s.column}>
            <Loader isLoading={isFetching} className={s.loader}>
              <div className={s.columnWrapper}>
                <h3 className={s.h3}>
                  {title && <span>{title} - </span>}
                  {amount} <FormattedMessage id="грн" />
                </h3>
                {!isFetching && balance > 0 && (
                  <div className={s.balance}>
                    <FormattedMessage id="Баланс" />:{' '}
                    <b>
                      {balance} <FormattedMessage id="грн" />
                    </b>
                  </div>
                )}
                <div className={s.list}>
                  {items.map(item => {
                    let shouldDisable =
                      (!item.isBalanceRefillOption && balanceRefillMode) ||
                      (item.isBalanceRefillOption && !balanceRefillMode);
                    // || (item.slug === PAYMENT_METHODS.INVOICE && !this.props.balanceRefillMode);
                    if (this.props.disableBalance) {
                      shouldDisable =
                        (item.slug === PAYMENT_METHODS.BALANCE && this.props.disableBalance) ||
                        (item.slug === PAYMENT_METHODS.INVOICE && !this.props.balanceRefillMode);
                    }
                    if (item.slug === PAYMENT_METHODS.FONDY_P24) shouldDisable = true;
                    // todo delete this functionality when privat24 will working
                    return shouldDisable ? null : (
                      <button
                        key={item.slug}
                        className={cx(s.payment, { [s.disabled]: isLoading })}
                        onClick={() => this.handleItemChosen(item)}
                        disabled={isLoading || !isChecked}
                      >
                        <div className={s.paymentContents}>
                          <img src={item.imgSrc} width={60} alt="" />
                          <div className={s.paymentTitle}>
                            {intl.formatMessage({ id: item.title })}
                          </div>
                        </div>
                      </button>
                    );
                  })}
                </div>
                <div className={s.actions}>
                  <button className={s.button} onClick={closeHandler}>
                    <FormattedMessage id="Отменить" />
                  </button>
                </div>
                <div className={s.contractOffer}>
                  <label
                    className={cx(
                      s.checkbox,
                      { [s.disabled]: isChecked },
                      { [s.mobile]: isMobile },
                    )}
                    onClick={() => this.setState({ isChecked: !isChecked })}
                  >
                    <input type="checkbox" defaultChecked={isChecked} />
                  </label>
                  <FormattedMessage id="При оплате услуг или пополнении личного кошелька, Пользователь подтверждает свое согласие с условиями" />{' '}
                  <a href="/public-contract/" target="_blank" rel="noopener noreferrer">
                    <FormattedMessage id="Публичного договора" />
                  </a>
                </div>
              </div>
            </Loader>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(s)(injectIntl(withBalance(true)(PaymentModal)));



// WEBPACK FOOTER //
// ./src/shared/components/PaymentModal/PaymentModal.js